<template>
  <div class="info-page">
    <crumbs title="用户管理" />
    <el-form
      :model="form"
      :rules="rules"
      ref="ruleForm"
      label-position="right"
      label-width="150px"
      disabled
    >
      <div class="info-page__item">
        <div class="info-page__title">
          <span>企业基本信息</span>
        </div>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="公司名称" prop="name">
              <el-input
                v-model="form.name"
                placeholder="请填写公司全称，与证件照保持一致"
                maxlength="50"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="统一社会信用代码/ 组织机构代码"
              prop="companyUniqueCode"
              class="special"
            >
              <el-input
                v-model="form.companyUniqueCode"
                maxlength="50"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="注册地址" prop="regionAddress">
              <region
                v-model="form.regionAddress"
                placeholder="请选择注册地址"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="成立时间" prop="foundingTime">
              <el-date-picker
                v-model="form.foundingTime"
                type="date"
                placeholder="请选择成立时间"
                value-format="yyyy-MM-dd"
                prefix-icon="el-icon-date"
                style="width: 100%"
              >
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="单位性质" prop="rtatCompanyNature">
              <enumerate
                v-model="form.rtatCompanyNature"
                url="/api/user/comnatureenum"
                placeholder="请选择单位性质"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="企业类型" prop="rtatType">
              <enumerate
                v-model="form.rtatType"
                url="/api/user/comtypeenum"
                placeholder="请选择企业类型"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="12">
          <el-col :span="12">
            <el-form-item label="法人代表姓名" prop="legalPerson">
              <el-input
                v-model="form.legalPerson"
                placeholder="请填写法人姓名"
                maxlength="15"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div class="info-page__item">
        <div class="info-page__title">
          <span>企业联系信息</span>
        </div>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="企业电话" prop="phoneNumber">
              <el-input
                v-model="form.phoneNumber"
                placeholder="请填写企业联系电话"
                maxlength="13"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="企业详细地址" prop="registerAddress">
              <el-input
                v-model="form.registerAddress"
                placeholder="请填写企业详细联系地址"
                maxlength="50"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div class="info-page__item">
        <div class="info-page__title">
          <span>认证人信息</span>
        </div>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="认证人姓名" prop="certifierName">
              <el-input
                v-model="form.certifierName"
                placeholder="请填写认证人姓名"
                maxlength="15"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="联系方式" prop="certifierPhoneNumber">
              <el-input
                v-model="form.certifierPhoneNumber"
                placeholder="请填写认证人联系电话"
                maxlength="13"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>

    <!-- 是否添加审核模块 -->
    <!-- 如果 certificationStatus 不等于1不允许审核 -->
    <template v-if="form.certificationStatus === 1">
      <el-form
        :model="aduitForm"
        :rules="aduitRules"
        ref="aduitForm"
        label-position="right"
        label-width="auto"
      >
        <div class="info-page__item">
          <div class="info-page__title">
            <span>审核</span>
          </div>
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item prop="status">
                <el-radio-group v-model="aduitForm.status" size="small">
                  <el-radio :label="2" border>通过</el-radio>
                  <el-radio :label="3" border>不通过</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10" v-if="aduitForm.status === 3">
            <el-col :span="24">
              <el-form-item prop="description">
                <el-input
                  v-model="aduitForm.description"
                  type="textarea"
                  :autosize="{ minRows: 3 }"
                  placeholder="不通过，请填写不通过原因"
                  maxlength="200"
                  show-word-limit
                  resize="none"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <div class="info-page__aduit fn-text-center mt-20">
        <el-button
          type="primary"
          :loading="isLoading"
          plain
          @click="handlerAduitData('aduitForm')"
          >提交审核</el-button
        >
      </div>
    </template>

    <div class="info-page__submit fn-text-center mt-20" v-if="false">
      <el-button
        type="primary"
        :loading="isLoading"
        plain
        @click="handlerModifyData('ruleForm')"
        >修改</el-button
      >
    </div>
  </div>
</template>

<script>
// 企业认证不允许修改
// 如果 certificationStatus 不等于1不允许审核
import CheckObj from "@/utils/check.js";
export default {
  name: "comCer",
  data() {
    const isEmpty = (
      message = "该项值不能为空",
      trigger = ["blur", "change"]
    ) => {
      return {
        required: true,
        message,
        trigger
      };
    };
    return {
      // 是否处于loading状态
      isLoading: false,
      //表单
      form: {
        // 企业基本信息
        name: "",
        companyUniqueCode: "",
        regionAddress: [],
        foundingTime: "",
        rtatCompanyNature: "",
        rtatType: "",
        legalPerson: "",
        // 企业联系信息
        phoneNumber: "",
        registerAddress: "",
        // 认证人信息
        certifierName: "",
        certifierPhoneNumber: ""
      },
      rules: {
        name: [isEmpty("请填写公司名称")],
        companyUniqueCode: [
          isEmpty("请填写统一社会信用代码/组织机构代码"),
          {
            validator: (rule, value, callback) => {
              if (value && !CheckObj.checkTradingCertificate(value)) {
                return callback(new Error("请填写正确的统一社会信用代码"));
              }
              callback();
            },
            trigger: "blur"
          }
        ],
        regionAddress: [isEmpty("请选择注册地址", "change")],
        foundingTime: [isEmpty("请选择成立时间", "change")],
        rtatCompanyNature: [isEmpty("请选择单位性质", "change")],
        rtatType: [isEmpty("请选择企业类型", "change")],
        legalPerson: [
          isEmpty("请填写法人姓名"),
          {
            validator: (rule, value, callback) => {
              if (value && !CheckObj.checkChineseName(value)) {
                return callback(new Error("请填写正确的法人姓名"));
              }
              callback();
            },
            trigger: "blur"
          }
        ],
        phoneNumber: [
          isEmpty("请填写企业联系电话"),
          {
            validator: (rule, value, callback) => {
              if (
                value &&
                !CheckObj.checkPhone(value) &&
                !CheckObj.checkTelephone(value)
              ) {
                return callback(
                  new Error("请填写正确的电话号码，座机格式如010-12345678")
                );
              }
              callback();
            },
            trigger: "blur"
          }
        ],
        registerAddress: [isEmpty("请填写企业详细联系地址")],
        certifierName: [
          isEmpty("请填写认证人姓名"),
          {
            validator: (rule, value, callback) => {
              if (value && !CheckObj.checkChineseName(value)) {
                return callback(new Error("请填写正确的认证人姓名"));
              }
              callback();
            },
            trigger: "blur"
          }
        ],
        certifierPhoneNumber: [
          isEmpty("请填写认证人联系电话"),
          {
            validator: (rule, value, callback) => {
              if (
                value &&
                !CheckObj.checkPhone(value) &&
                !CheckObj.checkTelephone(value)
              ) {
                return callback(new Error("请填写正确的电话号码"));
              }
              callback();
            },
            trigger: "blur"
          }
        ]
      },
      aduitForm: {
        status: 1,
        description: ""
      },
      aduitRules: {
        status: [
          {
            validator: (rule, value, callback) => {
              if (value === 1) {
                return callback(new Error("请选择是否通过"));
              }
              callback();
            },
            trigger: ["blur", "change"]
          }
        ],
        description: [isEmpty("请填写不通过原因")]
      }
    };
  },
  created() {
    //获取信息
    this.loadInfo();
  },
  methods: {
    // 正向处理数据 将数据处理后提交
    processDataSubmit() {
      const {
        // list
        regionAddress,
        ...others
      } = this.form;
      // 省市区
      const [provinceCode = "", cityCode = "", districtCode = ""] =
        regionAddress;

      return {
        ...others,
        provinceCode,
        cityCode,
        districtCode
      };
    },
    // 逆向处理数据 获取后进行数据处理回显
    downloadProcessData(data) {
      const {
        provinceCode = "",
        cityCode = "",
        districtCode = "",
        ...others
      } = data;

      return {
        ...others,
        regionAddress: [provinceCode, cityCode, districtCode]
      };
    },
    downloadProcessData2(data) {
      const { certificationStatus: status, certificationReason: description } =
        data;
      return { status, description };
    },
    // 点击审核数据按钮
    handlerAduitData(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loadAduitData();
        }
      });
    },
    // 加载审核数据接口
    loadAduitData() {
      this.isLoading = true;
      const { id } = this.$route.query;
      this.$api("user", "aduitComCerUser", { ...this.aduitForm, id }).then(
        (res) => {
          this.isLoading = false;
          this.$message({
            message: res.message,
            type: res.code === 0 ? "success" : "error"
          });
          if (res.code === 0) {
            this.redirectTo();
          }
        }
      );
    },
    // 点击修改数据按钮
    handlerModifyData(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loadModifyData();
        }
      });
    },
    // 加载修改数据接口
    loadModifyData() {
      this.isLoading = true;
      const params = this.processDataSubmit();
      const { id } = this.$route.query;
      this.$api("user", "modifyComCerUser", { ...params, id }).then((res) => {
        this.isLoading = false;
        this.$message({
          message: res.message,
          type: res.code === 0 ? "success" : "error"
        });
        if (res.code === 0) {
          this.redirectTo();
        }
      });
    },
    // 加载数据接口
    loadInfo() {
      const { id } = this.$route.query;
      this.$api("user", "getComCerInfo", {
        id
      }).then((res) => {
        const { code, message } = res;
        if (code === 0) {
          this.form = this.downloadProcessData(res.dataList[0]);
          this.aduitForm = this.downloadProcessData2(res.dataList[0]);
        } else {
          this.$message.error(message);
          this.redirectTo();
        }
      });
    },
    // 返回列表页
    redirectTo() {
      // this.redirectByPath(`/admin/userManage/userContentlist`);
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="less" scoped>
.info-page {
  /deep/ .el-form {
    .el-form-item {
      &.special {
        .el-form-item__label {
          line-height: 20px;
        }
      }
    }
  }
}
</style>
